import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FilePenLine, X } from "lucide-react";
import { api, BACKEND_URL } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const NEXT_LABEL = { 1: "Next: logo", 2: "Next: whitepaper", 3: "Next: publish" };

/** Signed-in creators with an unpublished draft get a one-tap "pick up where you left off" strip. */
export default function ResumeDraft({ className = "" }) {
  const { user } = useAuth();
  const [draft, setDraft] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!user) {
      setDraft(null);
      return;
    }
    api
      .get("/my/coins")
      .then((r) => {
        const d = (r.data.coins || []).find((c) => c.status === "draft");
        if (!d || sessionStorage.getItem(`resume_hidden_${d.slug}`)) return;
        setDraft(d);
      })
      .catch(() => {});
  }, [user]);

  if (!user || !draft || hidden) return null;

  const done = 1 + (draft.logo_mime ? 1 : 0) + (draft.has_whitepaper ? 1 : 0);
  const dismiss = () => {
    sessionStorage.setItem(`resume_hidden_${draft.slug}`, "1");
    setHidden(true);
  };

  return (
    <div className={className} data-testid="resume-draft-strip">
      <div className="border border-[#cfff04] bg-[#121212] px-5 py-3 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3 min-w-0">
          {draft.logo_mime ? (
            <img
              src={`${BACKEND_URL}/api/coins/${draft.slug}/logo`}
              alt=""
              className="w-9 h-9 flex-shrink-0 border border-[#3a3a3a] object-cover"
            />
          ) : (
            <FilePenLine size={18} className="text-[#cfff04] flex-shrink-0" />
          )}
          <div className="min-w-0">
            <div className="font-mono text-[11px] uppercase tracking-widest text-[#cfff04]">Resume your draft</div>
            <div className="text-sm truncate" data-testid="resume-draft-name">
              <span className="font-bold text-white">{draft.name}</span>
              <span className="text-[#e2e2e2]">
                {" "}· ${draft.ticker} · {done} of 4 steps done · {NEXT_LABEL[done]}
              </span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to={`/create?resume=${draft.slug}`}
            data-testid="resume-draft-cta"
            className="btn-brutal bg-[#cfff04] text-[#050505] font-bold uppercase tracking-wider text-[11px] px-4 py-2"
          >
            Resume →
          </Link>
          <button onClick={dismiss} data-testid="resume-draft-dismiss" aria-label="Dismiss" className="text-[#d0d0d0] hover:text-white">
            <X size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
